// extracted by mini-css-extract-plugin
export default {"wraaper":"CommingSoon_wraaper__EIU5f"};